import {
  AccountUserActionTypes,
  IFetchAccountUsersPayload,
  IFetchAccountUsersSuccessResponseBody,
  ICreateAccountUsersPayload,
  IDeleteAccountUsersPayload,
  IDeleteAccountUsersSuccessPayload,
  IChangeRolePayload,
  IChangeSelectedAccountUsersPayload,
} from './types'

export const resetAccountUsers = () => ({
  type: AccountUserActionTypes.RESET_ACCOUNT_USERS,
})

export const fetchAccountUsers = (payload: IFetchAccountUsersPayload) => ({
  type: AccountUserActionTypes.FETCH_ACCOUNT_USERS,
  payload,
})

export const fetchAccountUsersSuccess = (payload: IFetchAccountUsersSuccessResponseBody) => ({
  type: AccountUserActionTypes.FETCH_ACCOUNT_USERS_SUCCESS,
  payload,
})

export const fetchAccountUsersFailure = () => ({
  type: AccountUserActionTypes.FETCH_ACCOUNT_USERS_FAILURE,
})

export const createAccountUsers = (payload: ICreateAccountUsersPayload) => ({
  type: AccountUserActionTypes.CREATE_ACCOUNT_USERS,
  payload,
})

export const createAccountUsersSuccess = () => ({
  type: AccountUserActionTypes.CREATE_ACCOUNT_USERS_SUCCESS,
})

export const createAccountUsersFailure = () => ({
  type: AccountUserActionTypes.CREATE_ACCOUNT_USERS_FAILURE,
})

export const deleteAccountUsers = (payload: IDeleteAccountUsersPayload) => ({
  type: AccountUserActionTypes.DELETE_ACCOUNT_USERS,
  payload,
})

export const deleteAccountUsersSuccess = (payload: IDeleteAccountUsersSuccessPayload) => ({
  type: AccountUserActionTypes.DELETE_ACCOUNT_USERS_SUCCESS,
  payload,
})

export const deleteAccountUsersFailure = () => ({
  type: AccountUserActionTypes.DELETE_ACCOUNT_USERS_FAILURE,
})

export const changeRole = (payload: IChangeRolePayload) => ({
  type: AccountUserActionTypes.CHANGE_ROLE,
  payload,
})

export const changeRoleSuccess = () => ({
  type: AccountUserActionTypes.CHANGE_ROLE_SUCCESS,
})

export const changeRoleFailure = () => ({
  type: AccountUserActionTypes.CHANGE_ROLE_FAILURE,
})

export const changeSelectedAccountUsers = (payload: IChangeSelectedAccountUsersPayload) => ({
  type: AccountUserActionTypes.CHANGE_SELECTED_ACCOUNT_USERS,
  payload
})

export const unselectAccountUsers = () => ({
  type: AccountUserActionTypes.UNSELECT_ACCOUNT_USERS,
})

export const selectAllAccountUsers = () => ({
  type: AccountUserActionTypes.SELECT_ALL_ACCOUNT_USERS,
})
